import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
interface QuizQuestion {
  id: number;
  question: string;
  options: string[];
  correctAnswer: number;
  explanation: string;
}
const questions: QuizQuestion[] = [{
  id: 1,
  question: 'Ce este Suportul Individual CLC?',
  options: ['Un manual de proceduri', 'Un sistem de asistență personalizată 7/7 prin WhatsApp Business', 'O aplicație mobilă', 'Un curs online'],
  correctAnswer: 1,
  explanation: 'Suportul Individual CLC este un sistem unic de asistență personalizată 7/7, oferit prin grupuri WhatsApp Business dedicate fiecărui agent.'
}, {
  id: 2,
  question: 'Cine face parte din grupul individual de suport?',
  options: ['Doar managerul direct', 'Board, departamente specializate (legal, tehnic, fiscal, AI) și agentul', 'Doar colegii din echipă', 'Clientii agenției'],
  correctAnswer: 1,
  explanation: 'Grupul individual include membri ai Boardului și reprezentanți ai tuturor departamentelor specializate pentru a oferi suport complet.'
}, {
  id: 3,
  question: 'Care este scopul principal al Suportului Individual CLC?',
  options: ['Monitorizarea activității agenților', 'Ridicarea rapidă a nivelului de profesionalism și eliminarea blocajelor', 'Trimiterea de notificări', 'Organizarea de evenimente'],
  correctAnswer: 1,
  explanation: 'Scopul principal este dezvoltarea accelerată a fiecărui agent prin învățare asistată și rezolvarea rapidă a problemelor.'
}];
export function QuizSection() {
  const [answers, setAnswers] = useState<{
    [key: number]: number;
  }>({});
  const [showResults, setShowResults] = useState(false);
  const handleAnswer = (questionId: number, optionIndex: number) => {
    setAnswers(prev => ({
      ...prev,
      [questionId]: optionIndex
    }));
  };
  const handleSubmit = () => {
    setShowResults(true);
  };
  const score = questions.reduce((acc, q) => {
    return answers[q.id] === q.correctAnswer ? acc + 1 : acc;
  }, 0);
  return;
}